import React from 'react';
import { Users, Flame, Award, Star } from 'lucide-react';
import { useLang } from '../context/LanguageContext';

export default function StatsSection() {
  const { lang } = useLang();
  const stats = [
    { icon: Users, value: '10,000+', label_en: 'Happy Devotees', label_hi: 'संतुष्ट ग्राहक' },
    { icon: Flame, value: '25,000+', label_en: 'Pujas Performed', label_hi: 'पूजाएं संपन्न' },
    { icon: Award, value: '150+', label_en: 'Expert Pandits', label_hi: 'अनुभवी पंडित' },
    { icon: Star, value: '4.8 / 5', label_en: 'Rating', label_hi: 'रेटिंग' }
  ];
  return (
    <section className="relative wine-dark py-14 md:py-16 px-4 sm:px-6 overflow-hidden">
      <div className="absolute inset-0 opacity-[0.05] pointer-events-none" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='80' height='80' viewBox='0 0 80 80'%3E%3Ctext x='0' y='55' font-size='55' fill='%23E9A756'%3Eॐ%3C/text%3E%3C/svg%3E")`
      }} />
      <div className="max-w-6xl mx-auto relative">
        <div className="text-center mb-8 md:mb-10">
          <span className="sanskrit-bar mb-3 inline-flex">|| <span className="devnag">सर्वे भवन्तु सुखिनः</span> ||</span>
          <h2 className="text-2xl md:text-4xl font-bold text-nv-cream mt-3">
            {lang === 'en' ? 'Our journey is your ' : 'हमारी आस्था '} <span className="gradient-text-on-dark">{lang === 'en' ? 'trust' : 'आपका आशीर्वाद'}</span>
          </h2>
          <p className="text-sm md:text-base text-nv-cream/70 mt-2 max-w-xl mx-auto">
            {lang === 'en' ? 'Trusted by devotees across Bharat for authentic devotional services' : 'भारत भर के भक्तों की सच्ची भक्ति सेवा में जुड़ें'}
          </p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {stats.map((s, i) => (
            <div key={i} className="bg-white/5 border border-nv-gold/25 rounded-2xl p-5 md:p-6 text-center backdrop-blur-sm hover:bg-white/10 transition group">
              <div className="w-12 h-12 md:w-14 md:h-14 mx-auto mb-3 rounded-full bg-nv-gold/20 flex items-center justify-center text-nv-gold-light group-hover:scale-110 transition">
                <s.icon className="w-5 h-5 md:w-6 md:h-6" />
              </div>
              <div className="text-2xl md:text-3xl font-bold gradient-text-on-dark">{s.value}</div>
              <div className="text-xs md:text-sm text-nv-cream/75 mt-1">{lang === 'en' ? s.label_en : s.label_hi}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
